import {
    AllEvents,
    DataLayerEventName,
    EntitledToView,
} from '@news-mono/web-common'
import React, { useCallback } from 'react'
import {
    StyledFootyLivesHereLink,
    StyledFootyLivesHerePromoCard,
    StyledPromoImg,
} from './FootyLivesHerePromoCard.styled'

export type FootyLivesHerePromoCardProps = {
    use2025Images: boolean
    onEvent?: (event: AllEvents) => void
}

export const EntitledView: React.FC<FootyLivesHerePromoCardProps> = ({
    use2025Images,
    onEvent,
}) => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-In.jpg')
    const promoNew = require('./assets/2026_WA-Footy-Lives-Here-Tile-Logged-In-@1x.jpg')

    const onLinkClick = useCallback(() => {
        onEvent?.({
            type: DataLayerEventName.selectItemEvent,
            originator: 'AFLSeasonGuidePromoCard',
            payload: {
                index: 0,
                item_brand: 'The West Australian',
                item_category: 'news/promotions',
                item_category2: 'redirect',
                item_id: 'afl_season_guide_promo_card',
                item_list_category: 'sports-afl-season-guide-promo',
                item_list_category2: 'active-promotion',
                item_name: 'AFL Season Guide Promo Card',
                item_variant: false,
                price: 0.0,
                link_text: 'Read now',
                link_url:
                    'https://editions.thewest.com.au/ccidist-replica-reader/?epub=https://editions.thewest.com.au/ccidist-ws/other_publications/wan_afl_preseason/issues/23690/',
            },
        })
    }, [onEvent])

    return (
        <StyledFootyLivesHerePromoCard>
            {use2025Images ? (
                <StyledPromoImg
                    src={promo}
                    alt="Your season of AFL. 2026 AFL AAMI Origin Guide available 13th February. AFL Season Preview Guide available 4th March."
                />
            ) : (
                <StyledFootyLivesHereLink
                    to={
                        'https://editions.thewest.com.au/ccidist-replica-reader/?epub=https://editions.thewest.com.au/ccidist-ws/other_publications/wan_afl_preseason/issues/23690/'
                    }
                    openExternalInNewWindow={false}
                    onClick={onLinkClick}
                >
                    <StyledPromoImg
                        src={promoNew}
                        alt="Your season of AFL. Read the 2026 AFL Season Guide now."
                    />
                </StyledFootyLivesHereLink>
            )}
        </StyledFootyLivesHerePromoCard>
    )
}

export const OpportunityView: React.FC<FootyLivesHerePromoCardProps> = ({
    use2025Images,
}) => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-Out.jpg')
    const promoNew = require('./assets/2026_WA-Footy-Lives-Here-Tile-Logged-Out-@1x.jpg')
    return (
        <StyledFootyLivesHerePromoCard>
            <StyledFootyLivesHereLink to={'/sport/afl/subscribe'}>
                <StyledPromoImg
                    src={use2025Images ? promo : promoNew}
                    alt="Get a 12 month subscription to The West and receive a FREE WA AAMI AFL Origin Guernsey"
                />
            </StyledFootyLivesHereLink>
        </StyledFootyLivesHerePromoCard>
    )
}

export const FootyLivesHerePromoCard: React.FC<FootyLivesHerePromoCardProps> =
    ({ use2025Images, onEvent }) => {
        return (
            <EntitledToView
                requiredAccess={{ level: 'subscriber' }}
                entitled={() => {
                    return (
                        <EntitledView
                            use2025Images={use2025Images}
                            onEvent={onEvent}
                        />
                    )
                }}
                notEntitled={() => {
                    return <OpportunityView use2025Images={use2025Images} />
                }}
            />
        )
    }
